import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SidebarNavLink, SidebarWrapper } from '@components';
import { GlobalContext } from '@contexts';
import { legacyDashboardURL } from '@helpers';
import {
  ArrowLeftIcon,
  ClipboardIcon,
  LayoutIcon,
  ListIcon,
  PageIcon,
  SettingsIcon,
} from '@svgs';

export const TemplateSidebar = (props) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  return (
    <SidebarWrapper>
      <div className="sb-sidebar-nav">
        <div className="sb-sidebar-header">
          <Link
            to={`/dashboard/projects/${props.businessID}/templates`}
            className="sb-sidebar-back-btn sb-flex"
          >
            <ArrowLeftIcon />
            Back to Templates
          </Link>
        </div>
        <ul>
          <li className="sb-sidebar-nav-title">Template</li>
          <SidebarNavLink
            to={`/dashboard/projects/${props.businessID}/templates/${props.siteID}/pages`}
          >
            <PageIcon />
            Pages
          </SidebarNavLink>
          <SidebarNavLink
            to={`/dashboard/projects/${props.businessID}/templates/${props.siteID}/menus`}
          >
            <ListIcon />
            Menus
          </SidebarNavLink>
          <SidebarNavLink
            to={`/dashboard/projects/${props.businessID}/templates/${props.siteID}/fallbacks`}
          >
            <ClipboardIcon />
            Content fallbacks
          </SidebarNavLink>
          <li>
            <a
              href={legacyDashboardURL(`/app/builder/${props.siteID}`)}
              className="sb-flex sb-sidebar-item"
              target="_blank"
            >
              <LayoutIcon />
              Template editor
            </a>
          </li>
          <SidebarNavLink
            to={`/dashboard/projects/${props.businessID}/templates/${props.siteID}/blogs`}
          >
            <PageIcon />
            Blogs
          </SidebarNavLink>
        </ul>
        <ul>
          <li className="sb-sidebar-nav-title">Beta features</li>
          <SidebarNavLink
            to={`/dashboard/projects/${props.businessID}/templates/${props.siteID}/editor`}
          >
            <LayoutIcon />
            Inline template editor
          </SidebarNavLink>
        </ul>
      </div>
      <ul className="sb-sidebar-footer">
        <SidebarNavLink
          to={`/dashboard/projects/${props.businessID}/templates/${props.siteID}/settings`}
          tooltip="Update the settings for this Template"
        >
          <SettingsIcon />
          Template settings
        </SidebarNavLink>
      </ul>
    </SidebarWrapper>
  );
};
